export default class LeadFormType {
  static get BrochureFormPaid() {
    return this.getInstance('get-brochure-paid');
  }

  static get InformationFormPaid() {
    return this.getInstance('more-information-paid');
  }

  static get RequestTourForm() {
    return this.getInstance('request-a-tour');
  }

  static get InformationFormBasic() {
    return this.getInstance('get-information-basic');
  }

  static get AskQuestionFormPaid() {
    return this.getInstance('ask-question-paid');
  }

  static get ManufacturedBrochureFormPaid() {
    return this.getInstance('get-manufactured-brochure-paid');
  }

  static fromKey(key) {
    const formTypeMap = {
      'get-brochure-paid': LeadFormType.BrochureFormPaid,
      'more-information-paid': LeadFormType.InformationFormPaid,
      'request-a-tour': LeadFormType.RequestTourForm,
      'get-information-basic': LeadFormType.InformationFormBasic,
      'ask-question-paid': LeadFormType.AskQuestionFormPaid,
      'get-manufactured-brochure-paid': LeadFormType.ManufacturedBrochureFormPaid,
    };
    return formTypeMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new LeadFormType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(LeadFormType, 'instances', { value: {} });
